// Chip de priorité (WKF-013) — SOURCE DE VÉRITÉ unique de l'affichage des
// priorités (widget cloche, ligne page, sélecteur de la modale). Remplace les
// chevrons (Minus/ChevronUp/ChevronsUp) par des pastilles texte + couleur DS.
//
// Règles : NORMAL = rien en liste (baseline) ; HIGH = warning (ambre) ; URGENT =
// destructive (rouge/rose). Texte toujours présent (daltonisme). Aucun vert.

import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'

import type { Priority } from '@/hooks/useNotifications.types'
import { PRIORITY_CHIP, PRIORITY_CHIP_NORMAL } from './notification-config'

interface PriorityChipProps {
    priority: Priority
    /** Affiche aussi le chip « Normale » (sélecteur de priorité de la modale). */
    showNormal?: boolean
    className?: string
}

export function PriorityChip({ priority, showNormal = false, className }: PriorityChipProps) {
    const { t } = useTranslation()
    const cfg = priority === 'NORMAL' ? (showNormal ? PRIORITY_CHIP_NORMAL : null) : PRIORITY_CHIP[priority]
    if (!cfg) return null
    return (
        <span
            className={cn(
                'inline-flex h-5 items-center rounded-full px-2 text-xs font-medium leading-none whitespace-nowrap',
                cfg.className,
                className,
            )}
        >
            {t(cfg.labelKey)}
        </span>
    )
}
